import {DEFAULT_INTEREST} from "../../../credit_calculator/constants/calculations_defaults";
import {convertInterestToText} from "../../../credit_calculator/utils/convert_interest_to_text";
import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";

interface IProps {
    totalMax: number;
}

export const PropertyConfiguratorBudgetFilter = (props: IProps) => {
    const {totalMax} = props;

    return (
        <>
            <BudgetField
                key={`budget-field-${totalMax}`}
                radioName={BudgetFieldsNames.RADIO}
                type="switch"
                totalInputName={BudgetFieldsNames.TOTAL}
                monthlyInputName={BudgetFieldsNames.CREDIT}
                label="Budżet"
                totalMax={totalMax}
                useBudgetDynamicStep
                monthlyTitleTooltip={{
                    label: "Rata kredytu",
                    tooltip: `Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie ${convertInterestToText(DEFAULT_INTEREST)} oraz okresie kredytowania wynoszącym 30 lat.`
                }}
            />
        </>
    );
};
import {DEFAULT_INTEREST} from "../../../credit_calculator/constants/calculations_defaults";
import {convertInterestToText} from "../../../credit_calculator/utils/convert_interest_to_text";
import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";

interface IProps {
    totalMax: number;
}

export const PropertyConfiguratorBudgetFilter = (props: IProps) => {
    const {totalMax} = props;

    return (
        <>
            <BudgetField
                key={`budget-field-${totalMax}`}
                radioName={BudgetFieldsNames.RADIO}
                type="switch"
                totalInputName={BudgetFieldsNames.TOTAL}
                monthlyInputName={BudgetFieldsNames.CREDIT}
                label="Budżet"
                totalMax={totalMax}
                useBudgetDynamicStep
                monthlyTitleTooltip={{
                    label: "Rata kredytu",
                    tooltip: `Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie ${convertInterestToText(DEFAULT_INTEREST)} oraz okresie kredytowania wynoszącym 30 lat.`
                }}
            />
        </>
    );
};
